var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-checkbox-group",
    {
      staticClass: "ticket_form_checkbox",
      on: { change: _vm.onChange },
      model: {
        value: _vm.modelValue,
        callback: function($$v) {
          _vm.modelValue = $$v
        },
        expression: "modelValue"
      }
    },
    _vm._l(_vm.item.enums, function(e) {
      return _c("el-checkbox", { key: e.id, attrs: { label: e.id } }, [
        _vm._v(_vm._s(e.name))
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39d662f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39d662f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketFormCheckbox.vue
// module id = 896
// module chunks = 75